<template>
    <div class="channel-header-wrap">
        <div class="channel-focus" :style="{backgroundImage: 'url('+ channelBanner +')'}"
            ref="subFocusbox" :class="{'is-sticky':isSticky}">
            <!--
            <el-image
                style="width:100%;height: 100%;"
                :src="require('@/assets/img/'+ channel.banner +'')"
                fit="cover"></el-image>
            -->
        </div>
        <div class="sub-header" :style="subHeaderStyle" >
            <div class="sub-header-wrap sub-channel-menu-box" ref="subHeader">
                <div class="channel-title" ref="titleBox"><div>{{ channel.name }}</div></div>
                <!--
                <el-menu :default-active="activeIndex"
                        class="channel-menu"
                        mode="horizontal"
                        @select="handleMenuSelect">
                    <el-menu-item v-for="(item, i) in channel.children"
                        :index="item.alias"
                        :key="item.alias">{{ item.name }}
                    </el-menu-item>
                </el-menu>
                -->
                <!--
                <div class="channel-menu-box" ref="menuBox">
                    <el-tabs v-model="activeIndex"
                        ref="channelMenu"
                        @tab-click="handleMenuClick"
                        class="channel-menu">
                        <el-tab-pane v-for="(item, i) in channel.children"
                            :label="item.name"
                            :name="item.alias"
                            :key="item.alias"></el-tab-pane>
                    </el-tabs>
                </div>
                -->
                <div class="channel-menu-box" ref="menuBox">
                    <swiper class="menu-swiper" ref="menuswiper" :options="swiperOption">
                        <swiper-slide
                            class="menu-slide text-select-disable"
                            v-for="(item, i) in channel.children"                            
                            :key="item.alias"
                            >
                            <div       
                                class="menu-title  "                         
                                :class="{'is-active': activeIndex == item.alias}"
                                @click="handleMenuClick(item)">{{item.name}}</div>
                        </swiper-slide>                    
                    </swiper>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import "swiper/dist/css/swiper.css";
    import { swiper, swiperSlide } from 'vue-awesome-swiper';
    export default {
      components: { swiper, swiperSlide },
      props: {
        channel:{
            typeof: Object,
            default: ()=>({})
        },
        activeSub: null,
      },
      data() {
          return {
            activeIndex: null,
            tab: 0,
            channelBanner: require('@/assets/img/'+this.channel.banner),
            subHeaderStyle: 'position:static;',
            isSticky: false,

            swiperOption: {
              slidesPerView: 'auto',
              spaceBetween: 0,
              direction: 'horizontal', 
            },
          };
        },
      methods: {
        handleMenuSelect(index, indexPath){
            this.$router.push({
                path: '/' + this.channel.alias,
                query:{
                    tab: index
                }
            });
            
            this.onSelectChannel(index);
        },
        handleMenuClick(item){
            this.activeIndex = item.alias;
            if(item.type != null && item.type == 2 && item.link != null){
                //let routeData = this.$router.resolve({ path: item.link});
                window.open(item.link, '_blank');
            }else{
                this.$router.push({
                    path: '/' + this.channel.alias,
                    query:{
                        tab: item.alias
                    }
                });
            }
            this.onSelectChannel(item.alias);
        },
        onSelectChannel(alias){
            // 通知父级页面频道切换
            this.$emit('selectChannel', alias);
        },
        setActiveTabByIndex(tabIndex){
            if(tabIndex < 0){
                tabIndex = 0;
            }
            if(this.channel != null && this.channel.children != null){
                if(tabIndex < this.channel.children.length){
                    this.activeIndex = this.channel.children[tabIndex].alias;
                }
            }
        },

        pageScrollListener(){
            let screenW = document.documentElement.clientWidth;
            let headerHeight = 82;
            if(screenW < 700){
                headerHeight = 56;
            }
            let scollTop = document.body.scrollTop || document.documentElement.scrollTop;
            //let rect = this.$refs.subHeader.getBoundingClientRect();
            let rect = this.$refs.subFocusbox.getBoundingClientRect();

            if(rect.bottom <= headerHeight){
                this.subHeaderStyle =  'position:fixed;top:'+ headerHeight +'px;border-bottom:1px solid #DCDFE6;';
                this.isSticky = true;
            }else{
                this.subHeaderStyle =  'position:static;border:none;';
                this.isSticky = false;
            }
        },

        setMenubarSize(){
            let rc = this.$refs.subHeader.getBoundingClientRect();
            let boxWidth = rc.width;
            rc = this.$refs.titleBox.getBoundingClientRect();
            let titleWidth = rc.width;
            //let tabsWidth = this.$refs.channelMenu.$el.offsetWidth;
            // 设置 el-tabs__header 宽度
            
            let tabs = this.$refs.channelMenu.$el.querySelector('.el-tabs__nav');
            let maxW = boxWidth - titleWidth - 10 - 40;

            if(tabs != null){
                if(maxW < tabs.offsetWidth){
                    let ele = this.$refs.channelMenu.$el.querySelector('.el-tabs__header');
                    if(ele != null){
                        ele.style.width = maxW + 'px';
                    }
                }else{
                    let ele1 = this.$refs.channelMenu.$el.querySelector('.el-tabs__header');
                    if(ele1 != null){
                        ele1.style.width = (tabs.offsetWidth + 40) + 'px';
                    }
                }
            }
            
        },

      },
      created() {
        window.addEventListener('scroll', this.pageScrollListener);
        //window.addEventListener('resize', this.setMenubarSize);

        let tab = this.$route.query.tab;
        if(tab){
            this.activeIndex = tab;
            this.onSelectChannel(tab);
        }else{
            this.activeIndex = this.activeSub;
        }
      },
      destroyed(){
        window.removeEventListener('scroll', this.pageScrollListener);
        //window.removeEventListener('resize', this.setMenubarSize);
      },
      mounted() {
        this.$nextTick(()=>{
            //this.setMenubarSize();
        });
      }
    };
</script>

<style scoped>
    .channel-header-wrap{
        width: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
    }
    .channel-focus{
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
    }
    .is-sticky{
        margin-bottom: 61px;
    }
    .sub-header{
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 0px;
        gap: 30px;
        align-self: stretch;
        background: #FFFFFF;
        box-sizing: border-box;
        width: 100%;
        z-index: 1001;
    }
    .sub-header-wrap{
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-direction: row;        
        align-items: center;
        padding: 0px;
        gap: 10px;
        height: 50px;
    }
    .channel-title{
        font-size: 32px;
        font-weight: normal;
        line-height: 48px;
        letter-spacing: 0.12em;
        color: #000000;
        flex: 0 0 200px;
        height: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5px;
        box-sizing: border-box;
    }
    .channel-menu-box{
        flex-grow: 1;
        
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        
        box-sizing: border-box;
    }
    .channel-menu{
        /*
          display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-direction: row;
        */
    }
    .menu-swiper{
        margin-left: 0px;
        margin-right: 0px;      
        height: 100%;
        /*cursor: pointer;*/
    }

    .menu-slide{
        /*
          display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        */
        height: 48px;
        width: fit-content;        
        
    }
    .menu-slide .menu-title{
        font-size: 18px;
        letter-spacing: 0em;
        color: #3B3F47;
        padding: 0 8px;
        background: #F9F9F9;
        
        line-height: 48px;
        margin-right: 3px;      
        width: fit-content;   
        cursor: pointer;
    }
    .menu-slide .is-active{
        font-weight: bold;
        letter-spacing: 0em;
        color: #014289;
        background: #F9F9F9;
    }
    /deep/.channel-menu .el-tabs__header{
        margin: 0px;
        background: #fff;
    }
    /deep/.channel-menu .el-tabs__nav-wrap{
        margin-bottom: 0px;
    }
    /deep/.channel-menu .el-tabs__item{
        font-size: 18px;
        letter-spacing: 0em;
        color: #3B3F47;
        padding: 0 8px;
        background: #F9F9F9;
        height: 48px;
        line-height: 48px;
        margin-right: 3px;
    }

    /deep/.channel-menu .el-tabs__nav-wrap::after{
        height: 0px;
        display: none;
    }

    /deep/.channel-menu .el-tabs__item.is-active{
        font-weight: bold;
        letter-spacing: 0em;
        color: #014289;
        background: #F9F9F9;
    }


    /deep/.channel-menu .el-tabs__item.is-top:nth-child(2){
        padding-left: 8px;
    }
    /deep/.channel-menu .el-tabs__item.is-top:last-child{
        padding-right: 8px;
        margin-right: 0px;
    }


    /deep/.channel-menu .el-tabs__item.is-top:last-child{
        padding-right: 8px;
    }

    /deep/ .channel-menu .el-tabs__active-bar{
        display: none;
        height: 0px;
    }



    /deep/.el-menu.el-menu--horizontal,
    /deep/.el-menu--horizontal>.el-menu-item.is-active,
    /deep/.el-menu--horizontal>.el-menu-item{
        border-bottom: none;
    }

    /deep/.el-menu--horizontal>.el-menu-item{
        font-size: 18px;
        font-weight: bold;
        letter-spacing: 0em;
        color: #3B3F47;
        padding: 0px 15px;
        background: #F9F9F9;
    }
    /deep/.el-menu--horizontal>.el-menu-item.is-active{
        font-weight: bold;
        letter-spacing: 0em;
        color: #014289;
        background: #F9F9F9;
    }

    /deep/.el-menu--horizontal>.el-menu-item:hover,
    /deep/.el-menu--horizontal .el-menu-item:not(.is-disabled):hover{
        background: #F9F9F9;
        color: #014289;
    }
@media screen and (max-width:1400px){
    .sub-header-wrap{
        padding: 0px 10px;
    }
}
/*焦点图自适应屏幕*/
@media screen and (max-width:662px){
    .channel-focus{
        height: 160px;
    }
}
@media screen and (min-width:663px){
    .channel-focus{
        height: calc((407/1686)*100vw);
    }
}
@media screen and (max-width:700px){
    .sub-header-wrap{
        padding-left: 0px;
    }
    .channel-title{
        font-size: 14px;
        line-height: 14px;
        height: 100%;
        flex: 0 0 auto;
        background: #014289;
        color: #fff;
    }
    .menu-slide .menu-title{
        font-size: 16px;
    }
    .is-sticky{
        margin-bottom: 41px;
    }
}
@media screen and (min-width:601px) and (max-width:800px){
    .channel-title{
        font-size: 20px;
        flex: auto;
        padding-left: 20px;
        justify-content: left;
        min-width: 150px !important;
    }
}
@media screen and (min-width:911px){
    .channel-focus{
        height: calc((407/1686)*100vw);
    }
}

@media screen and (min-width:1326px){
    .channel-focus{
        height: 320px;
    }
}

@media screen and (min-width:1921px){
    .channel-focus{
        height: calc((407/2440)*100vw);
    }
}

</style>



// WEBPACK FOOTER //
// src/components/channelheader/index.vue